/**
 * Container Component
 *
 * Abstraction layer over MUI Container.
 */

import { ContainerProps, Container as MuiContainer } from '@mui/material';
import React from 'react';

const Container = React.forwardRef<HTMLDivElement, ContainerProps>((props, ref) => {
  return <MuiContainer ref={ref} {...props} />;
});

Container.displayName = 'Container';

export default Container;
